


















































































































import { computed, defineComponent, reactive, ref } from "@vue/composition-api";
import Layout from "@/components/Atoms/Layout/index.vue";
import ThreadUserList from "@/components/Pages/Scout/Messages/ThreadUserList/index.vue";
import { MessageThreadUser } from "@/components/Pages/Scout/Messages/ThreadUserList/ThreadUser/types";
import CommentListContainer from "@/components/Pages/Scout/Messages/CommentListContainer/index.vue";
import ScoutMessageLargePanel from "@/components/Pages/Scout/Messages/ScoutMessageLargePanel/index.vue";
import { autoCloseToast } from "@/components/Pages/Scout/Candidates/methods";
import OccToast from "@/components/Atoms/OccToast/index.vue";
import DateTimeSubmitModal from "@/components/Pages/Scout/elements/modals/DateTimeSubmitModal/index.vue";
import { ThreadMessage } from "@/components/Pages/Scout/Messages/ScoutMessageLargePanel/types";
import dayjs from "dayjs";
import {
  deleteReservedComment,
  reserveThreadComment
} from "@/grpc-web/scout/message";
import OccModal from "@/components/Atoms/OccModal/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import RightDetailDrawer from "@/components/Pages/Scout/elements/RightDetailDrawer/index.vue";
import { MessageThreadsLastComment } from "@/components/Pages/Scout/Messages/ThreadUserList/ThreadUser/types";
import { CommentItem } from "@/components/Pages/Scout/Messages/CommentListContainer/CommentList/Comment/types";

interface ToastState {
  isVisible: boolean;
  message: string;
}

export default defineComponent({
  name: "Messages",
  components: {
    OccButton,
    OccModal,
    OccHeading,
    DateTimeSubmitModal,
    OccToast,
    Layout,
    ThreadUserList,
    CommentListContainer,
    ScoutMessageLargePanel,
    RightDetailDrawer
  },
  setup() {
    const currentMessageThreadUser = ref<MessageThreadUser | undefined>(
      undefined
    );
    const currentMessageThreadId = computed<number | undefined>(() => {
      return currentMessageThreadUser.value?.messageThreadId;
    });
    const currentUserImageUrl = computed<string | undefined>(() => {
      return currentMessageThreadUser.value?.userImageUrl;
    });

    const handleSelectMessageThreadUser = (threadUser: MessageThreadUser) => {
      currentMessageThreadUser.value = threadUser;
    };

    const reservationThreatMessageState = reactive({
      threadId: 0,
      messageText: ""
    });
    const isShowReservationSendThreadMessageModal = ref<boolean>(false);

    const handleClickedSendReservationMessage = (data: ThreadMessage) => {
      reservationThreatMessageState.threadId = data.threadId;
      reservationThreatMessageState.messageText = data.text;
      isShowReservationSendThreadMessageModal.value = true;
    };

    const commentUpdatedAt = ref<number | undefined>(undefined);
    const handleClickedSendMessage = () => {
      commentUpdatedAt.value = Date.now();
      showToast("メッセージを送信しました。");
    };

    const deleteReservationSendThreadCommentId = ref<number>(0);
    const isShowDeleteReservationSendThreadMessageModal = ref<boolean>(false);

    const handleDeletedSendReservationMessage = (commentId: number) => {
      isShowDeleteReservationSendThreadMessageModal.value = true;
      deleteReservationSendThreadCommentId.value = commentId;
    };

    const handleClickedDeleteReservationSendThreadMessageCancel = () => {
      isShowDeleteReservationSendThreadMessageModal.value = false;
    };

    const handleSubmitDeleteReservationSendThreadMessage = async () => {
      await deleteReservedComment(deleteReservationSendThreadCommentId.value);

      isShowDeleteReservationSendThreadMessageModal.value = false;
      showToast("メッセージの送信予約を取り消しました。");
      commentUpdatedAt.value = Date.now();
    };

    const handleClickedCloseThreadMessageReservationModal = () => {
      isShowReservationSendThreadMessageModal.value = false;
    };

    const resetScoutMessage = ref<boolean>(false);
    const handleSubmitSendReservationThreadMessage = async (
      validatedDatetime: dayjs.Dayjs
    ) => {
      await reserveThreadComment(
        reservationThreatMessageState.threadId,
        reservationThreatMessageState.messageText,
        validatedDatetime.valueOf()
      );

      // 送信予約したのでスカウトメッセージをリセットする
      resetScoutMessage.value = !resetScoutMessage.value;

      isShowReservationSendThreadMessageModal.value = false;
      showToast("メッセージを送信予約しました。");
      commentUpdatedAt.value = Date.now();
    };

    const isShowDetailDrawer = ref<boolean>(false);
    const closableDetailDrawer = computed(() => {
      return isMouseOverOutSide.value && !isMouseOverDetailDrawer.value;
    });

    const detailUserId = ref<number>(0);
    const handleClickedOpenDetail = (userId: number) => {
      isShowDetailDrawer.value = true;
      detailUserId.value = userId;
    };

    const handleClickedCloseDetailDrawer = () => {
      if (closableDetailDrawer.value) {
        isShowDetailDrawer.value = false;
      }
    };

    const outsideClickHandler = () => {
      isShowDetailDrawer.value = false;
    };

    const isMouseOverDetailDrawer = ref<boolean>(false);
    const handleMouseOverDetailDrawer = () => {
      isMouseOverDetailDrawer.value = true;
    };
    const handleMouseLeaveDetailDrawer = () => {
      isMouseOverDetailDrawer.value = false;
    };

    const isMouseOverOutSide = ref<boolean>(false);
    const handleMouseOverCommentList = () => {
      isMouseOverOutSide.value = true;
    };

    const handleMouseLeaveCommentList = () => {
      isMouseOverOutSide.value = false;
    };

    const threadUserDeletedAt = ref<number | undefined>(undefined);
    const handleThreadCommentNotFound = () => {
      threadUserDeletedAt.value = Date.now();
      currentMessageThreadUser.value = undefined;
    };

    const handleMouseOverThreadUserList = () => {
      isMouseOverOutSide.value = true;
    };

    const handleMouseLeaveThreadUserList = () => {
      isMouseOverOutSide.value = false;
    };

    const handleMouseOverMessageLargePanel = () => {
      isMouseOverOutSide.value = true;
    };

    const handleMouseLeaveMessageLargePanel = () => {
      isMouseOverOutSide.value = false;
    };

    const toastState = reactive<ToastState>({
      message: "",
      isVisible: false
    });

    // トーストメッセージを表示する
    const showToast = (message: string) => {
      toastState.message = message;
      toastState.isVisible = true;
      autoCloseToast(closeToast);
    };

    const closeToast = () => {
      toastState.isVisible = false;
    };

    const readThreadId = ref<number | undefined>(undefined);
    const handleReadThread = (threadId: number) => {
      readThreadId.value = threadId;
    };

    const messageThreadsLastComment = ref<
      MessageThreadsLastComment | undefined
    >(undefined);
    const handleUpdateThread = (lastComment: MessageThreadsLastComment) => {
      messageThreadsLastComment.value = lastComment;
    };

    const lastPartnerComment = ref<CommentItem | undefined>(undefined);
    const handleUpdateLastPartnerComment = (comment: CommentItem) => {
      lastPartnerComment.value = comment;
    };

    const lastPartnerCommentAlreadySent = computed<boolean>(() => {
      return lastPartnerComment.value?.alreadySent ?? false;
    });

    const reserveDateMaxDate = computed(() => {
      return dayjs()
        .add(3, "M")
        .format("YYYY/MM/DD");
    });

    return {
      currentMessageThreadId,
      currentUserImageUrl,
      handleSelectMessageThreadUser,
      handleClickedSendReservationMessage,
      handleClickedSendMessage,
      isShowReservationSendThreadMessageModal,
      isShowDeleteReservationSendThreadMessageModal,
      commentUpdatedAt,
      handleDeletedSendReservationMessage,
      handleClickedDeleteReservationSendThreadMessageCancel,
      handleSubmitDeleteReservationSendThreadMessage,
      resetScoutMessage,
      handleClickedCloseThreadMessageReservationModal,
      handleSubmitSendReservationThreadMessage,
      handleClickedOpenDetail,
      isShowDetailDrawer,
      detailUserId,
      handleClickedCloseDetailDrawer,
      handleMouseOverDetailDrawer,
      handleMouseLeaveDetailDrawer,
      handleMouseOverCommentList,
      handleMouseLeaveCommentList,
      threadUserDeletedAt,
      handleThreadCommentNotFound,
      handleMouseOverThreadUserList,
      handleMouseLeaveThreadUserList,
      handleMouseOverMessageLargePanel,
      handleMouseLeaveMessageLargePanel,
      readThreadId,
      handleReadThread,
      messageThreadsLastComment,
      handleUpdateThread,
      outsideClickHandler,
      toastState,
      closeToast,
      lastPartnerCommentAlreadySent,
      handleUpdateLastPartnerComment,
      reserveDateMaxDate
    };
  }
});
